import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const WarningSquareOutline = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 18 18">
    <path
      // eslint-disable-next-line max-len
      d="M 17 0 H 1 C 0.45 0 0 0.45 0 1 V 17 C 0 17.55 0.45 18 1 18 H 17 C 17.55 18 18 17.55 18 17 V 1 C 18 0.45 17.55 0 17 0 Z M 8.541 4 H 9.459 C 9.75 4 9.979 4.25 9.955 4.54 L 9.5 11 H 8.5 L 8.045 4.54 A 0.498 0.498 0 0 1 8.541 4 Z M 9 14 C 8.429 14 8 13.571 8 13 S 8.429 12 9 12 S 10 12.429 10 13 S 9.571 14 9 14 M 1 1 L 17 1 L 17 17 L 1 17 Z"
    ></path>
  </SvgIcon>
);

export default WarningSquareOutline;
